import App from './MainApp.vue'
//import VueGtag from "vue-gtag";

import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import SubscriptionService from './services/subscriptionservice'
import UserService from './services/userService'
import AccessService from './services/accessService'
import { VueQueryPlugin } from '@tanstack/vue-query';
/*import 'element-ui/lib/theme-chalk/index.css';*/
import 'element-plus/dist/index.css';
import './index.css';
import router from './routes';
import axios from 'axios';

import { useViewAs } from './composables/useViewAs'

axios.defaults.baseURL = '/';

// Inject viewAs query param into axios GET requests when viewing as another user
const { getViewAsParam, isViewingAsOther, clearViewAs } = useViewAs()
axios.interceptors.request.use((config) => {
  const viewAs = getViewAsParam()
  if (viewAs && config.method === 'get') {
    config.params = config.params || {}
    config.params.viewAs = viewAs
  }
  return config
})

// Handle 403 responses when viewing as another user
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 && isViewingAsOther.value) {
      clearViewAs()
      import('element-plus').then(({ ElNotification }) => {
        ElNotification({ title: 'Access denied', message: 'Returning to your account', type: 'warning' })
      })
    }
    return Promise.reject(error)
  }
)

const app = createApp(App);

app.provide('SubscriptionService', SubscriptionService);
app.provide('UserService', UserService);
app.provide('AccessService', AccessService);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(ElementPlus);
app.use(VueQueryPlugin);
/*app.use(VueGtag, {
    config: {
        id: "G-5GZDW592KV",
        params: {
            send_page_view: false
        }
    }

});*/

app.use(router);
app.mount('#MainPage')